'use client';

/**
 * Aviso de "el perfil cambió", para las vistas que traen sus datos por su cuenta.
 *
 * Existe por un caso concreto: `OwnerCvView` no se pinta en el servidor, hace su
 * propio `fetch` a `perfil-completo` al montarse. Cuando algo lo modifica desde
 * fuera —el hub de Preferencias agregando un teléfono, por ejemplo—, ni revalidar
 * el caché ni `router.refresh()` lo tocan: el primero invalida el servidor para la
 * próxima visita, el segundo redibuja componentes de servidor, y ese componente ya
 * está montado con los datos que pidió. Sin este aviso hay que recargar a mano.
 *
 * Se emite DESPUÉS de que la mutación respondió OK.
 */

const EVENTO = 'siiv-perfil-actualizado';

/** Avisa que el perfil de `slug` cambió. No-op fuera del navegador. */
export function emitirPerfilActualizado(slug: string): void {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent(EVENTO, { detail: slug }));
}

/**
 * Se suscribe a los cambios de UN perfil. Devuelve la función para desuscribirse,
 * lista para retornar desde un `useEffect`.
 */
export function suscribirPerfilActualizado(slug: string, alCambiar: () => void): () => void {
	if (typeof window === 'undefined') return () => {};

	const handler = (event: Event) => {
		if ((event as CustomEvent<string>).detail === slug) alCambiar();
	};
	window.addEventListener(EVENTO, handler);
	return () => window.removeEventListener(EVENTO, handler);
}

/**
 * Se suscribe a los cambios de CUALQUIER perfil: para las vistas que sólo conocen el id del investigador (la marca de
 * "cambio de unidad pendiente", que vuelve a consultar sus solicitudes). Devuelve la función para desuscribirse.
 */
export function suscribirCualquierPerfilActualizado(alCambiar: () => void): () => void {
	if (typeof window === 'undefined') return () => {};

	const handler = () => alCambiar();
	window.addEventListener(EVENTO, handler);
	return () => window.removeEventListener(EVENTO, handler);
}
